import { render, staticRenderFns } from "./PlanEscritorio.vue?vue&type=template&id=580a3410&scoped=true"
import script from "./PlanEscritorio.vue?vue&type=script&lang=js"
export * from "./PlanEscritorio.vue?vue&type=script&lang=js"
import style0 from "./PlanEscritorio.vue?vue&type=style&index=0&id=580a3410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a3410",
  null
  
)

export default component.exports